import {axiosGetHandler, axiosPostHandler} from '../config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

// 获取用户房间列表
export function getRoomList (args) {
	let url = BASE_API + '/chatroom/room/get_user_room_list'
	return axiosGetHandler(url, args)
}

// 获取用户房间&私聊列表(混排)
export function getSessionList (args) {
	let url = BASE_API + '/chatroom/msg/get_session_list'
	return axiosGetHandler(url, args)
}

// 添加房间
export function createRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/create'
	return axiosPostHandler(url, args, formdata)
}

// 获取添加房间的房间模板
export function getRoomTemplate (args) {
	let url = BASE_API + '/chatroom/v1/room/templates'
	return axiosGetHandler(url, args)
}

// 获取房间的频道列表
export function getChannelList (args) {
	let url = BASE_API + '/chatroom/room/get_channel_list'
	return axiosGetHandler(url, args)
}

// 加入房间
export function enterRoom (args, formdata) {
	let url = BASE_API + '/chatroom/channel/enter_channel'
	return axiosPostHandler(url, args, formdata)
}

// 删除房间
export function deleteRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/delete'
	return axiosPostHandler(url, args, formdata)
}

// 从当前列表移除房间
export function removeRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/leave'
	return axiosPostHandler(url, args, formdata)
}

// 从组队助手里面移除房间
export function removeRoomFromTeamBox (args, formdata) {
	let url = BASE_API + '/chatroom/room/remove_team_rooms'
	return axiosPostHandler(url, args, formdata)
}

// 更新房间信息
export function updateRoomInfo (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/edit'
	return axiosPostHandler(url, args, formdata)
}

//获取房间成员列表
export function getRoomMemberList (args) {
  let url = BASE_API + '/chatroom/room/get_room_user_list'
  return axiosGetHandler(url, args)
}

//获取管理员与权限列表 
export function getRoomAdminList (args) {
  let url = BASE_API + '/chatroom/room/get_room_managers'
  return axiosGetHandler(url, args)
}

//给单个用户设置管理权限
export function editRoomManager (args, formdata) {
  let url = BASE_API + '/chatroom/room/edit_room_manager'
	return axiosPostHandler(url, args, formdata)
}

//获取置顶房间列表
export function getTopRoomList (args) {
  let url = BASE_API + '/chatroom/room/get_top_rooms'
  return axiosGetHandler(url, args)
}

//设置置顶房间，传全量ID列表
export function  updateTopRoomList (args, formdata) {
  let url = BASE_API + '/chatroom/room/update_top_rooms'
  return axiosPostHandler(url, args, formdata)
}

//邀请页面用作背景的简单数据
export function getInviteRoomInfo (args) {
  let url = BASE_API + '/chatroom/v2/room/invite/view'
  return axiosGetHandler(url, args)
}

//设置房间公开ID
export function setRoomCustomizedID (args, formdata) {
  let url = BASE_API + "/chatroom/v2/room/public"
  return axiosPostHandler(url, args, formdata)
}

//获取符合权限的ID
export function getMatchedUserList(args) {
  let url = BASE_API + '/chatroom/v2/room/users/search'
  return axiosGetHandler(url, args)
}


// 获取房间成员列表
export function getRoomMemberListByPage (args) {
	let url = BASE_API + '/chatroom/v2/room/users'
	return axiosGetHandler(url, args)
}

// 获取当前房间信息
export function getRoomInfo(formdata) {
	let url = BASE_API + '/chatroom/v3/room/view'
	return axiosPostHandler(url, {
		room_id: formdata.room_id,
	}, formdata);
}

//拖拽房间排序
export function dragRoom (args, formdata) {
  let url = BASE_API + "/chatroom/room/drag_room"
  return axiosPostHandler(url, args, formdata)
}

// 查看热门社区申请
export function checkApplyForHot (args, formdata) {
	let url = BASE_API + '/chatroom/v1/room/check_apply_hot';
	return axiosPostHandler(url, args, formdata)
}

// 申请热门社区
export function applyForHot (args, formdata) {
	let url = BASE_API + '/chatroom/v1/room/apply_hot';
	return axiosPostHandler(url, args, formdata)
}

// 房间操作日志
export function getRoomActionLog (args) {
	let url = BASE_API + '/chatroom/v2/room/log/action'
	return axiosGetHandler(url, args);
}

//获取有操作日志的users
export function getRoomLogUsers (args) {
	let url = BASE_API + '/chatroom/v2/room/log/user'
	return axiosGetHandler(url, args);
}

// 获取所有房间的设置（通知设置）
export function getRoomsSetting (args) {
	let url = BASE_API + '/chatroom/v1/room/rooms_settings'
	return axiosGetHandler(url, args);
}

// 获取申请修改热门房间信息
/* 
* @param {String} room_id
*/
export function getHotRoomApplyInfo (args) {
	let url = BASE_API + '/chatroom/v1/room/hot_apply_edit_info'
	return axiosGetHandler(url, args);
}

// 热门房间申请修改信息已读
/* 
* @param {String} room_id
*/
export function setHotRoomApplyRead (args, formdata) {
	let url = BASE_API + '/chatroom/v1/room/hot_apply_edit_read'
	return axiosPostHandler(url, args, formdata)
}

// 设置自己在本房间内的群名片
/* 
* @param {String} nickname
* @param {String} room_id
*/
export function setNicknameInRoom(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/nickname'
  return axiosPostHandler(url, args, formdata)
}

// 获取左侧房间列表
export function getSideFolders (args) {
	let url = BASE_API + '/chatroom/v2/folder/folders'
	return axiosGetHandler(url, args);
}

// 创建房间文件夹
export function createRoomFolder (args) {
	let url = BASE_API + '/chatroom/v2/folder/create'
	return axiosGetHandler(url, args);
}

// 编辑房间文件夹
export function editRoomFolder (args: object, formdata: { color: string; folder_name: string; folder_id: string }) {
	let url = BASE_API + '/chatroom/v2/folder/update'
  return axiosPostHandler(url, args, formdata)
}

// 左侧房间列表排序
export function sortSideFolders (args, formdata) {
	let url = BASE_API + '/chatroom/v2/folder/sort'
  return axiosPostHandler(url, args, formdata)
}

// 设置房间个性化
export function editRoomTheme (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/decorate'
  return axiosPostHandler(url, args, formdata)
}

// 获取房间背景审核状态
export function getRoomBgReviewStatus (args) {
	let url = BASE_API + '/chatroom/v2/room/decorate/applying'
  return axiosGetHandler(url, args)
}

// 修改房间背景审核已读
export function setRoomBgReviewRead (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/decorate/read'
	return axiosPostHandler(url, args, formdata)
}

// 禁言用户
export function banUser (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/ban'
	return axiosPostHandler(url, args, formdata)
}

// 第一次弹禁言弹窗后上报
export function clearBanNotify (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/clear_ban_notify'
	return axiosPostHandler(url, args, formdata)
}

// 编辑用户房间属性
export function editUserRoomSetting (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/user_room/edit'
  return axiosPostHandler(url, args, formdata)
}

// 房间等级列表
export function getRoomLevels (args) {
	let url = BASE_API + '/chatroom/v2/task/room_rights'
  return axiosGetHandler(url, args)
}

// 编辑房间属性
export function editRoomSetting (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/room/edit'
  return axiosPostHandler(url, args, formdata)
}

// 获取房间设置
export function getRoomSetting (args) {
	let url = BASE_API + '/chatroom/v2/settings/room'
  return axiosGetHandler(url, args)
}

// 获取房间游戏主题
export function getRoomGameThemes (args) {
	let url = BASE_API + '/chatroom/v2/settings/themes'
  return axiosGetHandler(url, args)
}

// 修改房间游戏主题
export function editRoomGameTheme (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/room/theme'
  return axiosPostHandler(url, args, formdata)
}

// 修改个人卡片游戏隐私
export function editUserGameTheme (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/user_room/theme'
  return axiosPostHandler(url, args, formdata)
}

// 修改房间默认设置
export function editRoomDefaultSetting (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/room/update'
  return axiosPostHandler(url, args, formdata)
}

// 批量管理成员列表接口
export function getManageMember (args, formdata) {
	let url = BASE_API + '/chatroom/v3/room/users_filter'
	return axiosPostHandler(url, args, formdata)
}

// 转让房间
export function transferRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/transfer'
	return axiosPostHandler(url, args, formdata)
}

// 房间绑定组队
export function bindTeam (args: object, formdata: { room_id: string; channel_id: string; appid: number; team_sync_room: number; room_sync_team: number }) {
	let url = BASE_API + '/chatroom/v2/room/bind_team'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间游戏主题
export function getRoomTeamGames (args: { room_id: string }) {
	let url = BASE_API + '/chatroom/v2/room/team_games'
  return axiosGetHandler(url, args)
}

// 获取用户屏幕共享时进房token
export function getAdditionToken (args: { room_id: string; channel_id: string; rear: string; }) {
	let url = BASE_API + '/chatroom/v2/screen_share/token'
  return axiosGetHandler(url, args)
}

// 房间绑定常玩游戏
export function bindGame (args: object, formdata: { game_ids: Array<number>; room_id: string; }) {
	let url = BASE_API + '/chatroom/v2/settings/room/game/bind'
	return axiosPostHandler(url, args, formdata)
}

// 设置房间验证问题和答案
export function setVerificationConfig(args, formdata): Promise<any> {
	let url = BASE_API + '/chatroom/v2/room/set_join_verify'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间设置验证问题和答案
export function getVerificationConfig(args): Promise<any> {
	let url = BASE_API + '/chatroom/v2/room/join_verify'
	return axiosGetHandler(url, args)
}

// 进入房间的验证
export function enterVerification(args, formdata){
	let url = BASE_API + '/chatroom/v2/room/verification'
	return axiosPostHandler(url, args, formdata)
}

// 设置新手引导配置
export function setNewMemberGuideConfig(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/set_customization'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间新手配置
export function getNewMemberGuideConfig(args){
	const url = BASE_API + '/chatroom/v2/room/customization'
	return axiosGetHandler(url, args)
}

// 获取可聊频道列表
export function getChatableChannelList(args){
    const url = BASE_API + '/chatroom/v2/room/chatable_channels'
	return axiosGetHandler(url, args)
}

// 解锁可聊频道
export function unlockChatableChannel(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/unlock_chatable_channels'
	return axiosPostHandler(url, args, formdata)
}

// 获取已加入房间列表
export function getJoinedRoomList(args){
	const url = BASE_API + '/chatroom/v2/room/joined'
	return axiosGetHandler(url, args)
}

// 获取房主或者管理员的房间列表
export function getManagerRoomList(args){
	const url = BASE_API + '/chatroom/v2/room/manage_list'
	return axiosGetHandler(url, args)
}

// 定制体验点击答案
export function editCustomizationAnswer(args, formdata){
	const url = BASE_API + '/chatroom/v2/room/customization/responses'
	return axiosPostHandler(url, args, formdata)
}

// 新用户初次进入完成新手引导
export function finishNewMemberGuide(args, formdata){
	const url = BASE_API + '/chatroom/v2/room/customization/finish'
	return axiosPostHandler(url, args, formdata)
}

// 定制频道设置
export function editUserRoomNotify(args, formdata){
	const url = BASE_API + '/chatroom/v2/settings/user_room/notify'
	return axiosPostHandler(url, args, formdata)
}

// 批量修改频道通知设置
export function editUserRoomNotifyBatch(args, formdata){
    const url = BASE_API + '/chatroom/v2/settings/user_room/batch_notify'
	return axiosPostHandler(url, args, formdata)
}

// 绑定房间相似游戏标签
export function bindSimilarGames(args, formdata){
	const url = BASE_API + '/chatroom/v2/settings/room/game/similar/bind'
	return axiosPostHandler(url, args, formdata)
}

// 上报首页房间曝光
export function reportRoomExposure(args, formdata){
	const url  = BASE_API + '/chatroom/v2/report/room'
	return axiosPostHandler(url, args, formdata)
}

// 发布、编辑房间公告
export function upsertRoomAnc(args, formdata){
	const url = BASE_API + '/chatroom/v2/room/anc/upsert'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间公告分页列表
export function getRoomAncList(args){
	const url = BASE_API + '/chatroom/v2/room/anc/list'
	return axiosGetHandler(url, args)
}

// 删除房间公告
export function deleteRoomAnc(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/anc/delete'
	return axiosPostHandler(url, args, formdata)
}

// 已读房间公告
export function reportRoomAncRead(args){
	const url = BASE_API + '/chatroom/v2/room/anc/read'
	return axiosGetHandler(url, args)
}

// 获取某个公告详情
export function getRoomAncDetail(args){
	const url = BASE_API + '/chatroom/v2/room/anc/find'
	return axiosGetHandler(url, args)
}

// 删除房间内用户信息
export function deleteUserMsg(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/del_user_msg'
	return axiosPostHandler(url, args, formdata)
}

// 获取邀请码邀请用户列表
export function getInviteCodeUsers(args){
	const url = BASE_API + '/chatroom/v2/invite/code/invited/users'
	return axiosGetHandler(url, args)
}

// 获取房间内邀请码人数前五名
export function getInviteCodeTopUsers(args){
	const url = BASE_API + '/chatroom/v2/invite/code/top_users'
	return axiosGetHandler(url, args)
}

// 搜索房间邀请用户
export function getFilterInviteUser(args){
	const url = BASE_API + '/chatroom/v2/invite/code/filter_user'
	return axiosGetHandler(url, args)
}

// 获取房间内用户通知设置
export function getRoomNotify(args){
	const url = BASE_API + '/chatroom/v2/settings/room/user/notify'
	return axiosGetHandler(url, args)
}

// 上报火花提醒时间
export function reportFireTipTime(args, formdata){
	const url = BASE_API + '/chatroom/v2/room/fire_flag_ts'
	return axiosPostHandler(url, args, formdata)
}

// 创建或者修改房间活动
export function upsertRoomActivity(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/act/upsert'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间活动列表
export function getRoomActivityList(args){
	const url = BASE_API + '/chatroom/v2/room/act/list'
	return axiosGetHandler(url, args)
}

// 参与房间活动
export function joinRoomActivity(args, formdata){
    const url = BASE_API + '/chatroom/v2/room/act/participate'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间活动参与用户列表
export function getActivityParticipants(args){
    const url = BASE_API + '/chatroom/v2/room/act/participates'
	return axiosGetHandler(url, args)
}

// 获取房间活动详情
export function getRoomActivityDetail(args) {
	const url = BASE_API + '/chatroom/v2/room/act'
	return axiosGetHandler(url, args)
}

// 上报房间活动已读活动
export function closeRoomActivityInterval(args) {
	const url = BASE_API + '/chatroom/v2/room/act/close'
	return axiosGetHandler(url, args)
}

// 获取可发言的频道列表
export function getTalkableChannel(args) {
  let url = BASE_API + '/chatroom/v2/channel/chat/list'
  return axiosGetHandler(url, args)
}

// 根据条件获取可发言的频道列表
export function getFilterChannel(args) {
  let url = BASE_API + '/chatroom/v2/channel/filter/list'
  return axiosGetHandler(url, args)
}

// 获取房间活跃数据
export function getRoomActiveData(args) {
  let url = BASE_API + '/chatroom/v2/room/active/data'
  return axiosGetHandler(url, args)
}

// 获取房间管理员列表
export function getRoomManagers(args) {
  let url = BASE_API + '/chatroom/v2/room_role/admins'
  return axiosGetHandler(url, args)
}
// 获取房间反馈类型列表
export function getRoomFeedbackTypes(args) {
  let url = BASE_API + '/chatroom/v2/room/feedback/list'
  return axiosGetHandler(url, args)
}

// 删除房间反馈
export function deleteRoomFeedback(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/feedback/delete'
  return axiosPostHandler(url, args, formdata)
}

// 创建或者修改房间反馈
export function upsertRoomFeedback(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/feedback/upsert'
  return axiosPostHandler(url, args, formdata)
}

// 获取频道所有反馈消息
export function getAllFeedbackMsgList(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/feedback/list'
  return axiosGetHandler(url, args)
}

// 反馈消息状态
export function upsertFeedbackState(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel_msg/feedback/finish'
  return axiosPostHandler(url, args, formdata)
}

// 获取房间公告类型列表
export function getRoomAncTypes(args) {
  let url = BASE_API + '/chatroom/v2/room/anc_tag/list'
  return axiosGetHandler(url, args)
}

// 更新房间公告列表
export function updateRoomAncTypes(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/anc_tag/update'
  return axiosPostHandler(url, args, formdata)
}

// 批量更新房间设置
export function batchUpdateRoomSetting(args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/room/update/batch'
  return axiosPostHandler(url, args, formdata)
}

// 获取消息对应的频道
export function getMsgChannels(args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/chans_info_with_cur_user'
  return axiosPostHandler(url, args, formdata)
}

// 获取频道信息
export function getChannelsByIds(args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/chans_info_with_ids'
  return axiosPostHandler(url, args, formdata)
}

// 编辑社群房间
export function editCommunityRoom(args, formdata) {
  let url = BASE_API + '/chatroom/v2/community/set'
  return axiosPostHandler(url, args, formdata)
}

// 编辑小黑盒个人主页展示
export function editAppShowInUserPage(args, formdata) {
  let url = BASE_API + '/chatroom/v2/community/show'
  return axiosPostHandler(url, args, formdata)
}

// 撤销热门房间信息修改
export function cancelHotRoomApplying(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/edit/delete'
  return axiosPostHandler(url, args, formdata)
}

// 热门房间信息修改已读
export function readHotRoomApplyingInfo(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/edit/read'
  return axiosPostHandler(url, args, formdata)
}

// 获取房间组队设置
export function getRoomTeamBind(args) {
  let url = BASE_API + '/chatroom/v2/room/team_bind'
  return axiosGetHandler(url, args)
}

// 设置房间组队设置
export function setRoomTeamBind(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/team_bind'
  return axiosPostHandler(url, args, formdata)
}

// 删除房间组队设置
export function deleteRoomTeamBind(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/team_bind/delete'
  return axiosPostHandler(url, args, formdata)
}

// 获取上次的发布记录
export function getRoomTeamBindSetting(args) {
  let url = BASE_API + '/chatroom/v2/room/team_bind/setting'
  return axiosGetHandler(url, args)
}

// 发布组队
export function publishRoomTeamBind(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/team_bind/publish'
  return axiosPostHandler(url, args, formdata)
}